import React from 'react';
import { motion } from 'framer-motion';
export function IdentificationSection() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} className="py-16 px-4 bg-gradient-to-b from-transparent to-card/30" data-id="element-64">
      <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-65">
        <h3 className="text-2xl md:text-3xl font-bold text-red-400" data-id="element-66">
          Y lo peor de todo…
        </h3>

        <p className="text-xl md:text-2xl font-semibold" data-id="element-67">
          Sabes que eres bueno en lo que haces.
        </p>

        <p className="text-lg md:text-xl text-gray-300" data-id="element-68">
          Ves a otros profesores con menos nivel, menos experiencia… pero con
          más alumnos, cobrando más y siempre llenos.
        </p>

        <p className="text-xl font-bold text-accent" data-id="element-69">Es frustrante.</p>

        <p className="text-lg text-gray-300" data-id="element-70">
          Porque en el fondo sabes que podrías estar mucho mejor.
        </p>
      </div>
    </motion.section>;
}